// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M16.18 13H5Q4.58 13 4.29 12.71T4 12 4.29 11.29 5 11H16.18L11.28 6.1Q10.98 5.8 10.99 5.4T11.3 4.7Q11.6 4.42 12 4.41T12.7 4.7L19.3 11.3Q19.45 11.45 19.51 11.63T19.57 12.01 19.51 12.39 19.3 12.72L12.7 19.32Q12.42 19.6 12.01 19.6T11.3 19.3Q11 19 11 18.59T11.3 17.88Z"/>';

/** Forward (arrows). */
const icon: IconData = {
  id: "arrow-right",
  name: "Forward",
  category: "arrows",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M16.18 13H4V11H16.18L10.58 5.4 12 4 20 12 12 20 10.57 18.6Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M16.18 13H5Q4.58 13 4.29 12.71T4 12 4.29 11.29 5 11H16.18L11.28 6.1Q10.98 5.8 10.99 5.4T11.3 4.7Q11.6 4.42 12 4.41T12.7 4.7L19.3 11.3Q19.45 11.45 19.51 11.63T19.57 12.01 19.51 12.39 19.3 12.72L12.7 19.32Q12.42 19.6 12.01 19.6T11.3 19.3Q11 19 11 18.59T11.3 17.88Z"/></g><path d="M16.18 13H5Q4.58 13 4.29 12.71T4 12 4.29 11.29 5 11H16.18L11.28 6.1Q10.98 5.8 10.99 5.4T11.3 4.7Q11.6 4.42 12 4.41T12.7 4.7L19.3 11.3Q19.45 11.45 19.51 11.63T19.57 12.01 19.51 12.39 19.3 12.72L12.7 19.32Q12.42 19.6 12.01 19.6T11.3 19.3Q11 19 11 18.59T11.3 17.88Z"/>',
    },
  },
  animation: () => import("../animations/arrow-right.js"),
};

export default icon;
